import React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const formatCountLabel = (value, singular, plural) => {
  const count = Number(value || 0);
  if (!Number.isFinite(count) || count <= 0) {
    return null;
  }

  return `${count} ${count === 1 ? singular : plural}`;
};

const renderSkeletonCards = () =>
  Array.from({ length: 4 }).map((_, index) => (
    <div key={`cliente-skeleton-${index}`} className="crm-postventa-client-selector__skeleton" aria-hidden="true">
      <span className="crm-postventa-client-selector__skeleton-radio" />
      <div className="crm-postventa-client-selector__skeleton-copy">
        <span className="crm-postventa-client-selector__skeleton-line is-title" />
        <span className="crm-postventa-client-selector__skeleton-line" />
      </div>
    </div>
  ));

const ClienteSelectorModal = ({
  show,
  onHide,
  search,
  onSearchChange,
  loading,
  error,
  results,
  selectedKey,
  onSelect,
  onRetry,
  onConfirm,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="crm-postventa-client-selector"
      contentClassName="crm-postventa-client-selector__content"
      backdropClassName="crm-postventa-client-selector__backdrop"
    >
      <div className="crm-postventa-client-selector__shell">
        <button type="button" className="crm-postventa-client-selector__close" onClick={onHide} aria-label="Cerrar selector de cliente">
          ×
        </button>

        <h3>Seleccionar cliente</h3>

        <div className="crm-postventa-client-selector__search">
          <FontAwesomeIcon icon={faMagnifyingGlass} />
          <Form.Control
            type="text"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Buscar por nombre, CUIT, terminal, comercio, razón social, legajo..."
          />
        </div>

        <div className="crm-postventa-client-selector__results" role="radiogroup" aria-label="Clientes disponibles">
          {loading ? (
            renderSkeletonCards()
          ) : error ? (
            <div className="crm-postventa-client-selector__empty">
              <p>No pudimos cargar los clientes.</p>
              <Button type="button" variant="light" onClick={onRetry}>
                Reintentar
              </Button>
            </div>
          ) : results.length === 0 ? (
            <div className="crm-postventa-client-selector__empty">
              No se encontraron clientes con la búsqueda ingresada.
            </div>
          ) : (
            results.map((cliente) => {
              const isSelected = selectedKey === cliente.groupKey;
              const terminalCount = formatCountLabel(cliente.terminales?.length, "TERMINAL", "TERMINALES");
              const comercioCount = formatCountLabel(cliente.comercios?.length, "COMERCIO", "COMERCIOS");
              const detailParts = [
                cliente.razonSocial ? String(cliente.razonSocial).toUpperCase() : "",
                cliente.cuit ? `CUIT ${cliente.cuit}` : "",
                terminalCount,
                comercioCount,
              ].filter(Boolean);

              return (
                <button
                  key={cliente.groupKey}
                  type="button"
                  role="radio"
                  aria-checked={isSelected}
                  className={`crm-postventa-client-selector__item ${isSelected ? "is-selected" : ""}`}
                  onClick={() => onSelect(cliente)}
                >
                  <span className="crm-postventa-client-selector__radio" aria-hidden="true">
                    <span />
                  </span>
                  <input
                    type="radio"
                    name="cliente-selector"
                    checked={isSelected}
                    readOnly
                    tabIndex={-1}
                    className="crm-postventa-client-selector__radio-input"
                  />
                  <span className="crm-postventa-client-selector__item-copy">
                    <strong>{String(cliente.nombreDeFantasia || cliente.razonSocial || "Sin nombre").toUpperCase()}</strong>
                    <span>{detailParts.join(" | ")}</span>
                  </span>
                </button>
              );
            })
          )}
        </div>

        <div className="crm-postventa-client-selector__actions">
          <button type="button" className="crm-postventa-client-selector__submit" onClick={onConfirm} disabled={!selectedKey}>
            Seleccionar
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ClienteSelectorModal;
